
export class CauseModel {
    id: string;
    operationTypeId: number;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/cause-param-model.ts